import { pdfjs } from "@getambush/react-pdf";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Providers } from "./providers";
import { useAuth } from "./features/login/context/AuthContext";
import { router } from "./router";
import { RegionProvider } from "./config/RegionContext";
import { applicationConfig } from "./config";

// Setup PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `${import.meta.env.BASE_URL}assets/pdf.worker.min.mjs`;

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

function AppEntry() {
  const auth = useAuth();
  router.update({ context: { auth } });
  return <App />;
}

createRoot(rootElement).render(
  <Providers>
    <RegionProvider region={applicationConfig.countryCode}>
      <AppEntry />
    </RegionProvider>
  </Providers>
);
